import RightArrow from '@shared/icons/right-arrow-gradient.svg';
import { useNavigate } from 'react-router-dom';

import * as S from './styles';

type CardType = {
  brandId: string;
  siteId: string;
  title: string;
  siteAccNumber: string;
};
const Card = ({ brandId, siteId, title, siteAccNumber }: CardType) => {
  const navigate = useNavigate();

  const changePage = () => {
    navigate(`/locations/${siteId}/${siteAccNumber}/brand-workshop/${brandId}`);
  };

  return (
    <div onClick={changePage} data-cy="siteOptions">
      <S.Root>
        <S.Title>{title}</S.Title>
        <S.Button>
          <img src={RightArrow} alt="" />
        </S.Button>
      </S.Root>
    </div>
  );
};

export default Card;
